<template>
    <header :class="[isLight ? 'lightmode' : 'darkmode']">
      <img alt="Logo" role="presentation" aria-describedby="brand-name creator-name" @click="changeCalc(-1)" :src="[isLight ? logoLight : logoDark]">
      <span id="brand-name" @click="changeCalc(-1)">Time calculator</span>
      <nav class="nav-links">
        <div id="tools" :class="[toolsOpen ? 'tools-open' : '']">
            <div aria-haspopup="listbox" :aria-expanded="toolsOpen" id="tools-link" :class="[isLight ? 'lightmode' : 'darkmode']" @click.stop="{toolsOpen = !toolsOpen;aboutOpen = false}">
                <button :class="[isLight ? 'lightmode' : 'darkmode']">Tools</button>
                <img v-if="toolsOpen" :class="[isLight ? 'lightmode' : 'darkmode']" :src="[isLight ? arrowLight : arrowDark]" id="tools-link-arrow-open" class="nav-bar-link-arrow" />
                <img v-else :class="[isLight ? 'lightmode' : 'darkmode']" :src="[isLight ? arrowLight : arrowDark]" id="tools-link-arrow-closed" class="nav-bar-link-arrow" />
            </div>
            <div role="menu" :ref="toolsRef" id="tools-dropdown" :class="[isLight ? 'lightmode' : 'darkmode',toolsOpen ? 'tools-open' : '']">
                <button role="menuitem" @click="changeCalc(1)" :class="[isLight ? 'lightmode' : 'darkmode']">Time calculations</button>
                <button role="menuitem" @click="changeCalc(2)" :class="[isLight ? 'lightmode' : 'darkmode']">Calendar conversions</button>
                <button role="menuitem" @click="changeCalc(3)" :class="[isLight ? 'lightmode' : 'darkmode']">Timezone conversions</button>
                <button role="menuitem" @click="changeCalc(4)" :class="[isLight ? 'lightmode' : 'darkmode']">Convert units of time</button>
            </div>
        </div>
        <div id="about">
            <div aria-haspopup="menu" :aria-expanded="aboutOpen" id="about-link" :class="[isLight ? 'lightmode' : 'darkmode']" @click.stop="{aboutOpen = !aboutOpen;toolsOpen = false}">
                <button :class="[isLight ? 'lightmode' : 'darkmode']">About</button>
                <img v-if="aboutOpen" :class="[isLight ? 'lightmode' : 'darkmode']" :src="[isLight ? arrowLight : arrowDark]" id="about-link-arrow-open" class="nav-bar-link-arrow" />
                <img v-else :class="[isLight ? 'lightmode' : 'darkmode']" :src="[isLight ? arrowLight : arrowDark]" id="about-link-arrow-closed" class="nav-bar-link-arrow" />
            </div>
            <div role="listbox" :ref="aboutRef" id="about-dropdown" :class="[isLight ? 'lightmode' : 'darkmode',aboutOpen ? 'about-open' : '']">
                <button role="menuitem" @click="changeCalc(5)" :class="[isLight ? 'lightmode' : 'darkmode']">Time calculator</button>
                <button role="menuitem" @click="changeCalc(6)" :class="[isLight ? 'lightmode' : 'darkmode']">Untitled 9</button>
            </div>
        </div>
    </nav>
      <div>
        <button :class="[isLight ? 'lightmode' : 'darkmode']" class="menu-button" @click="toggleMenuMobile">☰</button>
        <button :class="[isLight ? 'lightmode' : 'darkmode']" class="theme-button" @click="changeTheme">☼</button>
      </div>
    </header>
</template>

<script setup>
 import { defineEmits,defineProps,toRef,ref, onMounted, onUnmounted } from 'vue';
 import { useRouter } from 'vue-router';
 import arrowLight from '../../public/arrow_lightmode.png';
 import arrowDark from '../../public/arrow_darkmode.png';
 import logoLight from '../../public/logo_lightmode.png';
 import logoDark from '../../public/logo_darkmode.png';

 const emit = defineEmits(['toggle-menu-mobile','change-theme']);
 const props = defineProps({
    darkMode:Boolean
 });
 const router = useRouter();

 var isLight = toRef(props,'darkMode');
 var toolsOpen = ref(false),aboutOpen = ref(false);
 const toolsRef = ref(null),aboutRef = ref(null);

 const toggleMenuMobile = () => {
    emit('toggle-menu-mobile');
 }

 const changeTheme = () => {
    emit('change-theme');
 }

 const changeCalc = (a) =>
{
    switch(a)
    {
        case 1:
        {
            router.push('/simple-calculator');
            break;
        }

        case 2:
        {
            router.push('/calendar-converter');
            break;
        }

        case 3:
        {
            router.push('/timezone-converter');
            break;
        }

        case 4:
        {
            router.push('/unit-converter');
            break;
        }

        case 5:
        {
            router.push('/about');
            break;
        }

        case 6:
        {
            router.push('/untitled-9');
            break;
        }

        default:
        {
            router.push('/');
            break;
        }
    }
}

const changeToMobile = () =>
{
    if (window.innerWidth < 770) 
    {
        toolsOpen.value = false;
        aboutOpen.value = false;
    }
}

const closeDropdowns = (event) =>
{
    if (toolsOpen.value) toolsOpen.value = false;
    if(aboutOpen.value) aboutOpen.value = false;
}

onMounted(() => 
{
    changeToMobile();
    window.addEventListener('resize',changeToMobile);
    window.addEventListener('click',closeDropdowns);
});

onUnmounted(() =>
{
    window.removeEventListener('resize',changeToMobile);
    window.removeEventListener('click',closeDropdowns);
});
</script>

<style scoped>
    header
    {
        grid-area: 1 / 1 / 2 / 2;
        display:grid;
        grid-template-rows: 2fr 1fr;
        grid-template-columns: 60px 1fr 50px;
        position:sticky;
        top:0;
        z-index: 5;
        border-bottom:2px solid #92929254;
        /*box-shadow:rgba(1, 1, 1, 0.2) -3px 3px 11px -3px;
        -webkit-box-shadow:rgba(1, 1, 1, 0.2) -3px 3px 11px -3px;*/
    }

    header.darkmode
    {
        background-color: #2b3133;
    }

    header.lightmode
    {
        background-color: #F7F7F6;
    }

    img
    {
        grid-area: 1 / 1 / -1 / 2;
        height: 45px;
        cursor:pointer;
        align-self: center;
        justify-self: right;
    }

    header div
    {
        grid-area: 1 / 3 / -1 / 4;
        display:flex;
        flex-direction: row;
        justify-content: end;
    }

    header span#brand-name
    {
        grid-area: 1 / 2 / 3 / 3;
        justify-self: start;
        align-self:center;
        font-size: clamp(1rem,18vw - 2rem,2rem);
    }

    span
    {
        font-family: Syne;
        color:#5F8B4C;
        margin:0;
        padding:0;
        cursor:pointer;
        user-select: none;
    }

    header div button
    {
        justify-self:center;
        align-self: center;
        width:45px;
        height: 45px;
        color:#281F18;
        padding:0;
        font-family:Syne;
        font-size:30px;
        border:none;
        border-radius:6px;
        background-color:#11111100;
        cursor:pointer;
    }

    header div button.menu-button
    {
        display: block;
    }

    header div button.theme-button
    {
        display:none;
    }

    header div button.lightmode
    {
        color: #2b3133;
    }

    header div button.darkmode
    {
        color: #F7F7F6;
    }

    .nav-links
    {
        grid-area: 1 / 3 / 3 / 4;
        display: none;
        flex-direction: row;
        justify-content: start;
        padding-top:20px;
        align-items: start;
        width:100%;
        height:auto;
    }

    #tools-link,#about-link
    {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width:fit-content;
        height: 24px;
        cursor:pointer;
    }

    #tools-link.lightmode,#about-link.lightmode
    {
        border-bottom:2px solid #F7F7F6;
    }
    
    #tools-link.darkmode,#about-link.darkmode
    {
        border-bottom:2px solid #2b3133;
    }

    #tools-link.lightmode:hover,#about-link.lightmode:hover
    {
        border-bottom:2px solid #2b3133;
    }

    #tools-link.darkmode:hover,#about-link.darkmode:hover
    {
        border-bottom:2px solid #F7F7F6;
    }

    img.nav-bar-link-arrow
    {
        height:30px;
    }

    img#tools-link-arrow-open,img#about-link-arrow-open
    {
        transform: scaleY(-1);
    }

    .nav-links button
    {
        width: fit-content;
        font-size: 25px;
    }

    .nav-links button.lightmode
    {
        color:#2b3133;
    }

    .nav-links button.darkmode
    {
        color:#F7F7F6;
    }

    .nav-links #tools,.nav-links #about,#tools-dropdown,#about-dropdown
    {
        display: none;
        flex-direction: column;
    }

    #tools
    {
        margin-right:43px;
    }

    #tools.tools-open
    {
        margin-right:-30px;
    }

    #tools-dropdown,#about-dropdown
    {
        align-items: start;
    }

    #tools-dropdown button,#about-dropdown button
    {
        font-size: 16px;
        text-align: left;
        width:100%;
        height:28px;
    }

    #tools-dropdown button:hover,#about-dropdown button:hover
    {
        text-decoration: underline;
    }

    #tools-dropdown.lightmode
    {
        border:2px solid #2b3133;
        background-color: #F7F7F6;
    }

    #tools-dropdown.darkmode
    {
        border:2px solid #F7F7F6;
        background-color: #2b3133;
    }

    #about-dropdown.lightmode
    {
        border:2px solid #2b3133;
        background-color: #F7F7F6;
    }

    #about-dropdown.darkmode
    {
        border:2px solid #F7F7F6;
        background-color: #2b3133;
    }

    @media (min-width: 770px)
    {
        header
        {
            grid-template-columns: 60px 3fr 2fr 50px;
        }

        header div button.menu-button
        {
            display: none;
        }

        header div button.theme-button
        {
            display:block;
        }

        header div
        {
            grid-area: 1 / 4 / -1 / 5;
        }

        .nav-links
        {
            display: flex;
        }

        .nav-links #tools,.nav-links #about
        {
            display: flex;
        }

        #tools-dropdown,#about-dropdown
        {
            display:none;
        }

        #tools-dropdown.tools-open,#about-dropdown.about-open
        {
            display: flex;
        }
    }
</style>